import { render, staticRenderFns } from "./DataSection.vue?vue&type=template&id=840cf174&scoped=true&"
import script from "./DataSection.vue?vue&type=script&lang=js&"
export * from "./DataSection.vue?vue&type=script&lang=js&"
import style0 from "./DataSection.vue?vue&type=style&index=0&id=840cf174&prod&lang=css&"
import style1 from "@assets/css/data_section.css?vue&type=style&index=1&id=840cf174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840cf174",
  null
  
)

export default component.exports